import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { changeUserStatus, searchUsers } from '../../../api/sportaloka-client';
import FilterModal from '../components/FilterModal';
import { format } from 'date-fns';
import Swal from 'sweetalert2';

function BookingsTable({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'created_at',
    sort_value: 'desc',
    status: '',
    fullname: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: paginationOptions.status,
        email: paginationOptions.email,
        fullname: paginationOptions.fullname
      }).toString();
      const response = await searchUsers(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (status, email, fullname) => {
    let filterLength = 0;
    if (status) {
      filterLength = filterLength + 1;
    }
    if (email) {
      filterLength = filterLength + 1;
    }
    if (fullname) {
      filterLength = filterLength + 1;
    }
    setPaginationOptions({ ...paginationOptions, status, fullname, email });
    onFilterLengthChanged(filterLength);
  };

  const handleChangeStatus = async (id) => {
    try {
      setLoading(true);
      await changeUserStatus(id);
      Swal.fire({
        title: 'Berhasil!',
        text: `Berhasil mengubah status`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      getData();
    } catch (error) {
      console.log(error.message);
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda dan coba lagi`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <FilterModal onFilter={handleFilter} />
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Nama Lengkap</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Email</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Status</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Tanggal Dibuat</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-center">
              Aksi
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="8">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="8">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="8">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {row.fullname}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {row.email}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                <span
                  className={`${row.status === 'ACTIVE' ? 'bg-success' : 'bg-danger'} text-white fw-600 px-2 py-1 rounded`}
                  style={{ fontSize: 12 }}>
                  {row.status === 'ACTIVE' ? 'AKTIF' : 'NONAKTIF'}
                </span>
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {format(new Date(row.created_at), 'dd/MM/yyyy')}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-center pe-0">
                <button
                  onClick={() => handleChangeStatus(row.id)}
                  className="fw-500 text-blue-1 btn btn-primary text-white btn-sm border-blue-1 mr-10">
                  {row.status === 'ACTIVE' ? 'Nonaktifkan' : 'Aktifkan'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default BookingsTable;
